import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" fill="#323433" fill-opacity="0.7" />
        <path
          d="M32.791 33.9587L22.3743 23.542C21.541 24.2364 20.5827 24.7781 19.4993 25.167C18.416 25.5559 17.3327 25.7503 16.2493 25.7503C13.5549 25.7503 11.2843 24.8264 9.43768 22.9787C7.5899 21.132 6.66602 18.8753 6.66602 16.2087C6.66602 13.542 7.5899 11.2848 9.43768 9.43699C11.2843 7.59032 13.541 6.66699 16.2077 6.66699C18.8743 6.66699 21.1382 7.59032 22.9993 9.43699C24.8605 11.2848 25.791 13.542 25.791 16.2087C25.791 17.3753 25.5827 18.5003 25.166 19.5837C24.7493 20.667 24.2077 21.5837 23.541 22.3337L33.9994 32.792L32.791 33.9587ZM16.2493 24.0837C18.4438 24.0837 20.3049 23.327 21.8327 21.8137C23.3605 20.2992 24.1243 18.4309 24.1243 16.2087C24.1243 13.9864 23.3605 12.1181 21.8327 10.6037C20.3049 9.09033 18.4438 8.33366 16.2493 8.33366C14.0271 8.33366 12.1521 9.09033 10.6243 10.6037C9.09657 12.1181 8.33268 13.9864 8.33268 16.2087C8.33268 18.4309 9.09657 20.2992 10.6243 21.8137C12.1521 23.327 14.0271 24.0837 16.2493 24.0837ZM15.416 20.167V17.042H12.2493V15.3753H15.416V12.2503H17.0827V15.3753H20.2077V17.042H17.0827V20.167H15.416Z"
          fill="white"
        />
      </svg>
      ;
    </Icons>
  );
}
